import React, { FC, ReactNode } from 'react';
import StepModal from '@components/stepModal';

import classnames from 'classnames/bind';
import styles from './tutorialGuide.module.scss';
const cx = classnames.bind(styles);

interface IStepSlide {
  leftContent: ReactNode;
  rightContent: ReactNode;
}

const stepSlideList: IStepSlide[] = [
  {
    leftContent: (
      <div className={cx('infoWrap')}>
        <strong className={cx('title')}>
          튜토리얼에서는
          <br />
          개발 구현 능력 검사 유형을
          <br />
          마음껏 연습해 볼 수 있어요.
        </strong>
      </div>
    ),
    rightContent: <div className={cx('visualArea', 'step2', 'pst')} />,
  },
  {
    leftContent: (
      <div className={cx('infoWrap')}>
        <strong className={cx('title')}>
          개발 구현 능력 검사는
          <br />
          단계별로 추가 조건이 제시되기 때문에
          <br />
          코드 확장성이 중요한 검사에요.
        </strong>
      </div>
    ),
    rightContent: <div className={cx('visualArea', 'step3', 'pst')} />,
  },
  {
    leftContent: (
      <div className={cx('infoWrap')}>
        <strong className={cx('title')}>
          실전 응시를 위해
          <br />
          튜토리얼에서 충분히 연습해보세요.
          <br />
          {''}
          <br />
          지금부터 출발!
        </strong>
      </div>
    ),
    rightContent: <div className={cx('visualArea', 'finish')} />,
  },
];

interface ITutorialGuideModalProps {
  visible: boolean;
  onClose: () => void;
  onApply: () => void;
}

const TutorialGuideModal: FC<ITutorialGuideModalProps> = ({ visible, onClose, onApply }) => {
  return <StepModal visible={visible} onClose={onClose} onApply={onApply} stepSlideList={stepSlideList} />;
};

export default TutorialGuideModal;
